/**
 * Adds a loading-indicator to submit buttons and handles its display states.
 *
 * @param {object} [options={}] - Optional options.
 * @param {string|NodeList|HTMLElement} [options.form='form:not([target="_blank"])'] - The form selector or the form element(s).
 * @param {string} [options.indicatorClass='has-loading-indicator'] - The class to set to the submit-button.
 * @param {string} [options.loadingClass='is-loading'] - The class to set to indicate loading.
 * @param {string} [options.exclude=''] - Selector for excluding certain submit inputs from attaching the indicator.
 *
 * @returns {NodeList|HTMLElement} The form(s) found by <code>options.form</code>.
 */
export async function loadingIndicator(options = {}) {
    const form = options.form || 'form:not([target="_blank"])',
        forms = typeof form === 'string' ? document.querySelectorAll(form) : form;

    if (forms.length) {
        let { initIndicator } = await import(/* webpackMode: "lazy" */ './inc/loading-indicator.async');

        initIndicator(forms, options);
    }

    return forms;
}
